import React from "react";

export default function LogosSection() {
  return (
    <section className="bg-[#002342] py-6 md:py-[30px] px-4 md:px-[220px]">
      <div className="flex items-center justify-center gap-4 md:gap-[20px] flex-wrap">
        <img src="/assets/landing-2025/logo-afroreggae-white.png" alt="AfroReggae" className="h-[25px] md:h-[38px] w-auto" />
        <img src="/assets/landing-2025/logo-white.png" alt="Logo 1" className="h-[28px] md:h-[42px] w-auto" />
        <img src="/assets/landing-2025/vuss-logo-white.png" alt="VUSS" className="h-[28px] md:h-[42px] w-auto" />
        <img src="/assets/landing-2025/kincaid-branco-763910.png" alt="Kincaid" className="h-[20px] md:h-[31px] w-auto" />
        <img src="/assets/landing-2025/logo-ruas-branco-6d2314.png" alt="Ruas" className="h-[32px] md:h-[48px] w-auto" />
        <img src="/assets/landing-2025/srcom-branco.png" alt="SRCom" className="h-[10px] md:h-[16px] w-auto" />
        <img src="/assets/landing-2025/sempre-movimento-logo-branco.png" alt="Sempre Movimento" className="h-[25px] md:h-[39px] w-auto" />
        <img src="/assets/landing-2025/logo-sbm-offshore-branco.png" alt="SBM Offshore" className="h-[18px] md:h-[27px] w-auto" />
        <img src="/assets/landing-2025/cidades-invisiveis-logo-branco.png" alt="Cidades Invisíveis" className="h-[13px] md:h-[20px] w-auto" />
        <img src="/assets/landing-2025/globo-logo-branco.png" alt="Globo" className="h-[33px] md:h-[50px] w-auto" />
        <img src="/assets/landing-2025/jolly-brasil-branco-25b608.png" alt="Jolly Brasil" className="h-[33px] md:h-[50px] w-auto" />
        <img src="/assets/landing-2025/sony-pictures-branco.png" alt="Sony Pictures" className="h-[22px] md:h-[53px] w-auto" />
        <img src="/assets/landing-2025/reverse-branco.png" alt="Reverse" className="h-[20px] md:h-[30px] w-auto" />
      </div>
    </section>
  );
}
